import ReactOnRails from 'react-on-rails';

import StickyAddToBasket from 'components/product_show/sticky_add_to_basket';
import FetchProductShowPrice from 'components/product_show/fetch_product_show_price';
import ProductCompare from 'components/product_show/product_compare';
import ProductPriceBreaks from 'components/product_show/product_price_breaks';
import SpottedMistake from 'components/spotted_mistake/spotted_mistake';

import RelatedProductsCarousel from 'components/related_products_carousel/related_products_carousel';
import ProductShowCarousel from 'components/product_show/product_carousel/product_carousel';
import ProductShowRenewables from 'components/product_show/renewables_product_show_column';
import ProductActions from 'components/product_show/product_actions';

ReactOnRails.register({
  StickyAddToBasket,
  FetchProductShowPrice,
  ProductCompare,
  ProductPriceBreaks,
  SpottedMistake,
  RelatedProductsCarousel,
  ProductShowCarousel,
  ProductShowRenewables,
  ProductActions,
});
